import { ContentCard } from "@msuite/ui/content-card";
import { Divider } from "@msuite/ui/divider";
import { icon } from "@msuite/ui/icons";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { ProtocolFormTypeCallRequestCallFor } from "./call-request/protocol-form-type-call-request-call-for";
import { ProtocolFormTypeCallRequestCallPriority } from "./call-request/protocol-form-type-call-request-call-priority";
import { ProtocolFormTypeCallRequestCalledBy } from "./call-request/protocol-form-type-call-request-called-by";

export function ProtocolFormTypeCallRequestDetails() {
	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();
	const type = useWatch({ control: methods.control, name: "type" });

	/** Guard */
	if (type !== "call-request") return null;

	/** Render */
	return (
		<ContentCard
			title="Call Request Details"
			icon={icon("Headset")}
			variant="plain"
			contentClassName="gap-4"
		>
			<ProtocolFormTypeCallRequestCalledBy />
			<Divider variant="content-card" />
			<ProtocolFormTypeCallRequestCallFor />
			<ProtocolFormTypeCallRequestCallPriority />
		</ContentCard>
	);
}
